import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnChanges, OnDestroy, OnInit, HostBinding, HostListener, SimpleChanges, ViewChild, Input, ElementRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatMenu } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { User } from 'src/app/model/user';
import { SidebarService } from '../../service/sidebar.service';
import { SidebarItem, AdminSidebarItem } from '../../model/sidebar-item';
import { Router } from '@angular/router';
import { ViewModeService } from '../../service/view-mode.service';
import { AuthService } from '../../service/auth.service';
import { NotificationService } from '../../service/notification.service';
import { ThemePalette } from '@angular/material/core';
import { InfoService } from '../../service/info.service';
import { AdminService } from '../../service/admin.service';
import { UserService } from 'src/app/service/user.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Event } from 'src/app/model/event';
import { MatDialog } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { CHAIR_LAYOUTS, LayoutService } from '../../service/layout.service';
import { HelpdeskOverlayService } from '../../service/helpdesk-overlay.service';
import { AvatarProfileComponent } from '../avatar-profile/avatar-profile.component';

@Component({
  selector: 'app-admin-event-sidebar',
  templateUrl: './admin-event-sidebar.component.html',
  styleUrls: ['./admin-event-sidebar.component.scss'],
  animations: [
    // Quick accordion reveal for the experimental sidebar's level-2 children
    // panel. `height: *` lets Angular measure the actual content height for
    // the open transition, so the animation works for any number of items.
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: 0, overflow: 'hidden' }),
        animate('140ms cubic-bezier(0.25, 0.8, 0.25, 1)',
                style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ overflow: 'hidden' }),
        animate('140ms cubic-bezier(0.25, 0.8, 0.25, 1)',
                style({ height: '0', opacity: 0 }))
      ])
    ]),
  ]
})
export class AdminEventSidebarComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  // ─── Mobile layout (TPC chair, viewport < 768px) ─────────────────────
  // `mobileLayoutActive` is driven by a `matchMedia('(max-width: 768px)')`
  // listener registered in `ngOnInit`. While true, the template adds the
  // `.mobile-layout` class to the root `.sidebar` and renders the mobile
  // chrome (top bar, bottom nav, sheets). Existing Modern/Classic chrome
  // is hidden via SCSS rules scoped to `.sidebar.mobile-layout`.
  mobileLayoutActive = false;

  // Backing field for the `.submenu-closed` class on `.sidebar`. Updated
  // via the mat-sidenav's `(openedChange)` event (NOT computed inline
  // from `content.opened`) so the value is stable within a single
  // change-detection cycle — avoids NG0100
  // ExpressionChangedAfterItHasBeenCheckedError when the sidenav's
  // `[opened]` resolves after the parent ngClass had already evaluated
  // the binding once with `content` undefined.
  submenuClosed = false;
  // When non-null, a bottom sheet listing the level-2 children of this
  // top-level item is rendered. Mutually exclusive with `mobileMoreSheetOpen`
  // — opening one resets the other (see openMobileSheet / openMobileMoreSheet).
  mobileSheetOpenFor: SidebarItem | null = null;
  // When true, a bottom sheet listing the overflow topItems (topItems.slice(5))
  // is rendered. Tapping a row inside it transitions to a topItem sheet.
  mobileMoreSheetOpen = false;
  // Cached matchMedia handle + listener so we can clean up in ngOnDestroy.
  private mobileMediaQuery: MediaQueryList | null = null;
  private mobileMediaListener: ((e: MediaQueryListEvent) => void) | null = null;

  // Handler de `document:mousemove` registrado FORA da zona do Angular (ver
  // ngOnInit). Bound aqui p/ ter a mesma referência em add/removeEventListener.
  private readonly boundDocMouseMove = (e: MouseEvent) => this.onDocumentMouseMove(e);

  @ViewChild('content', { static: true }) contentNav: MatSidenav;
  // Direct ref to the experimental sidebar's scroll container so we can read
  // scrollTop/scrollHeight to decide when to show the top/bottom dividers.
  @ViewChild('experimentalSidebarItems') experimentalSidebarItemsRef: ElementRef<HTMLElement>;
  // Ref to the custom flyout <aside>. Used by the document-click handler
  // to test whether the click landed inside the flyout (don't close) or
  // outside (close). Only present in the DOM while `flyoutOpenForItem`
  // is set, hence the loose typing.
  @ViewChild('experimentalFlyout') experimentalFlyoutRef: ElementRef<HTMLElement> | undefined;

  @ViewChild('avatarProfile') avatarProfile: AvatarProfileComponent;
  isAvatarProfileOpen: Boolean = false;
  @ViewChild('expUserBtn') expUserBtn: ElementRef<HTMLButtonElement>

  // Scroll-indicator flags for the experimental sidebar items area:
  // `experimentalItemsScrolledFromTop` becomes true once the user has scrolled
  // down at all (i.e., there's hidden content above) → header gets a
  // bottom-divider; `experimentalItemsHasMoreBelow` is true while there's
  // still hidden content below → bottom rail gets a top-divider.
  experimentalItemsScrolledFromTop = false;
  experimentalItemsHasMoreBelow = false;
  @Input() event: Event;
  @Input() topItems: SidebarItem[] = [];
  @Input() bottomItems: SidebarItem[] = [];
  selectedItem: SidebarItem;
  searchForm: FormGroup;

  notificationMenu: MatMenu;

  selectedItemMenu = false;
  selectedElement: string;
  userIsAdmin = false;
  user: User;
  // `imageAvatarUrl` pode apontar pra uma foto que existe no banco mas falha
  // ao carregar (404, arquivo removido, etc.) — sem isso o <img> ficava com o
  // ícone de imagem quebrada em vez de cair pro ícone de fallback.
  imageError = false;

  // Submenu width — user-resizable via the drag handle on the submenu's right edge.
  // Persisted to localStorage, with min/max clamp.
  static readonly SUBMENU_MIN_WIDTH = 143;
  static readonly SUBMENU_MAX_WIDTH = 400;
  static readonly SUBMENU_STORAGE_KEY = 'jems3-admin-submenu-width';
  submenuWidth = 165;
  isResizingSubmenu = false;
  isHoveringResizeHandle = false;

  // Experimental single-sidebar (A/B comparison): tracks which top-level
  // item is currently expanded so its children render below it in an
  // accordion. Only one item is expanded at a time.
  expandedExperimentalItem: SidebarItem | null = null;

  // In collapsed (icon-rail) mode, this tracks which level-1 item's flyout
  // is currently open. The custom `<aside class="experimental-flyout">`
  // sibling renders only when this is non-null. Drives the `.expanded`
  // visual class on the trigger button.
  flyoutOpenForItem: SidebarItem | null = null;
  // Fixed-position coordinates for the custom flyout aside (px). Computed
  // from the trigger button's getBoundingClientRect at open time and on
  // window resize / scroll while open.
  flyoutTopPx = 0;
  flyoutLeftPx = 0;
  // The trigger button currently owning the open flyout. The
  // document:mousedown handler uses it to detect "clicked the same
  // trigger" — that case is handled by `toggleFlyout` itself (toggling
  // closed), so the document handler must not also try to close.
  private flyoutOpenButton: HTMLElement | null = null;

  private resizeStartX = 0;
  private resizeStartWidth = 0;

  // Experimental sidebar width — user-resizable via a drag handle on its
  // right edge (same pattern as the submenu). Wider clamp range because
  // level-1 rows hold icon+text.
  static readonly EXPERIMENTAL_SIDEBAR_MIN_WIDTH = 180;
  static readonly EXPERIMENTAL_SIDEBAR_MAX_WIDTH = 420;
  static readonly EXPERIMENTAL_SIDEBAR_STORAGE_KEY = 'jems3-experimental-sidebar-width';
  static readonly EXPERIMENTAL_SIDEBAR_COLLAPSED_KEY = 'jems3-experimental-sidebar-collapsed';
  static readonly FAVORITES_STORAGE_KEY = 'jems3-favorited-items';
  static readonly FAVORITES_EXPANDED_KEY = 'jems3-favorites-expanded';
  // Per-event memory: qual level-1 item está expandido em cada evento. JSON
  // map `{ eventId: stableLabelKey }`. Restaurado em ngOnChanges quando o
  // event/topItems mudam; persistido em toggleExperimentalItem / onFlyoutChildClicked.
  // Favoritos NÃO entra aqui — tem o seu próprio FAVORITES_EXPANDED_KEY global.
  static readonly EXPANDED_BY_EVENT_STORAGE_KEY = 'jems3-admin-sidebar-expanded-by-event';
  experimentalSidebarWidth = 240;
  isResizingExperimentalSidebar = false;
  isHoveringExperimentalResizeHandle = false;
  isExperimentalSidebarCollapsed = false;

  // Favoritos is the only level-1 item with an INDEPENDENT expand/collapse
  // state. Other items go through `expandedExperimentalItem` (mutually
  // exclusive — only one open at a time); Favoritos uses this boolean so
  // the user can keep their starred shortcuts visible while still
  // expanding other groups below. Default `true` so the feature is
  // discoverable on first load.
  favoritesExpanded = true;

  // Ordered list of `AdminSidebarItem.link` values the user has favorited.
  // Persisted to localStorage so the picks AND their order survive across
  // sessions. Using `link` as the key because (a) it's unique per route
  // and (b) it's stable across the re-instantiation of `topItems` that
  // happens on every navigation — instance identity wouldn't survive that.
  // Order matters: it drives the sequence rendered in the Favoritos panel,
  // and is mutated by `onFavoriteReorder` (cdkDrag drop handler) so the
  // user can drag-reorder their shortcuts.
  favoritedLinks: string[] = [];

  // Legacy chrome (activity-bar + submenu) visibility — driven by
  // `LayoutService`. `false` = Modern layout (experimental sidebar only);
  // `true` = Classic layout (legacy chrome restored). The SCSS rule
  // `.sidebar.legacy-chrome-disabled` handles the visual hiding and the
  // content-area offset adjustments when this is `false`.
  legacyChromeEnabled = false;

  // Wide mode — driven by `LayoutService.wideMode$`. When `true`, the
  // chair chrome (experimental sidebar in Modern, activity-bar + classic
  // submenu in Classic) hides via the `.sidebar.wide-mode` rule below;
  // the breadcrumb manages its own slide-out and hover-reveal behavior.
  wideModeActive = false;

  // Helpdesk — estado do card vem do HelpdeskOverlayService (Subject).
  // Usado pra preencher o ícone (`.menu-open` no template).
  isSupportCardOpen = false;

  // Toggle via service — CDK Overlay ancora o card ao próprio botão
  // (FlexibleConnectedPositionStrategy + reflow em scroll/resize +
  // backdrop transparente + ESC), mesma stack do mat-menu do sino.
  openSupportHelp(event?: MouseEvent): void {
    const target = (event?.currentTarget ?? event?.target) as HTMLElement | undefined;
    // Garante que o trigger seja o <button>, não a tag interna (mat-icon, span).
    const trigger = target?.closest?.('.helpdesk-button') as HTMLElement | null;
    this.helpdeskOverlay.toggle(trigger ?? target);
  }


  // Classic-only — open/close state of the custom `<aside class="classic-
  // submenu">` element that replaced `<mat-sidenav>` in this layout. The
  // mat-sidenav was trapped inside `mat-sidenav-container`'s stacking
  // context, blocking the z-index hierarchy from putting the submenu
  // above the toolbar's drop shadow. The new element lives at the
  // `.sidebar` root, so its z-index competes with the toolbar's directly.
  classicSubmenuOpen = true;

  private experimentalResizeStartX = 0;
  private experimentalResizeStartWidth = 0;

  constructor(
    public router: Router,
    public authService: AuthService,
    private fb: FormBuilder,
    public notificationService: NotificationService,
    public infoService: InfoService,
    private userService: UserService,
    public adminService: AdminService,
    private dialog: MatDialog,
    private elementRef: ElementRef<HTMLElement>,
    private layoutService: LayoutService,
    private helpdeskOverlay: HelpdeskOverlayService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    public viewMode: ViewModeService,
  ) { }

  // ─── Mobile layout helpers ──────────────────────────────────────────
  /** First 4 items after Favoritos (`topItems[0]`). Renders as the bottom
   *  nav's 4 main slots; the 5th slot is the "Mais" trigger. */
  get mobileBottomNavItems(): SidebarItem[] {
    if (!this.topItems || this.topItems.length === 0) return [];
    return this.topItems.slice(1, 5);
  }

  /** Items beyond the first 5 (topItems[5..]). Shown in the "Mais" sheet. */
  get mobileOverflowItems(): SidebarItem[] {
    if (!this.topItems || this.topItems.length <= 5) return [];
    return this.topItems.slice(5);
  }

  /** True when the current router URL falls under `item.link`. Used to
   *  paint the active state on the bottom-nav slot. Mirrors the prefix
   *  match in `initSidenav` (longest-prefix wins, but here a simple
   *  contains check is enough since the caller iterates slot-by-slot
   *  and only one slot will match in practice). */
  isCurrentTopItem(item: SidebarItem): boolean {
    if (!item || !item.link || !this.router?.url) return false;
    const url = this.router.url;
    return url === item.link || url.startsWith(item.link + '/');
  }

  openMobileSheet(item: SidebarItem): void {
    this.mobileMoreSheetOpen = false;
    this.mobileSheetOpenFor = item;
  }

  openMobileMoreSheet(): void {
    this.mobileSheetOpenFor = null;
    this.mobileMoreSheetOpen = true;
  }

  closeMobileSheet(): void {
    this.mobileSheetOpenFor = null;
    this.mobileMoreSheetOpen = false;
  }

  /** Click handler for a row inside a sheet. Navigates (handled by the
   *  template's [routerLink]) and closes the sheet. */
  onMobileSheetChildClicked(): void {
    this.closeMobileSheet();
  }

  /** Within the "Mais" sheet, tapping a row opens THAT item's children
   *  sheet (so the user lands on the same surface they'd have hit from
   *  a primary nav slot). */
  onMobileMoreRowClicked(item: SidebarItem): void {
    this.openMobileSheet(item);
  }

  /** Applies the current submenuWidth as a CSS custom property on the host
   *  element. CSS variables cascade, so all descendants (.sidebar, the
   *  resize handle, mat-sidenav, .workspace-bar) read the new value via
   *  `var(--admin-submenu-width)`.
   *  Angular 11's `[style.--var]` / `[ngStyle]` bindings do not propagate
   *  custom properties reliably; setProperty() always works. */
  private applySubmenuWidth(): void {
    this.elementRef.nativeElement.style.setProperty(
      '--admin-submenu-width',
      this.submenuWidth + 'px'
    );
    this.applyCanvasLeftOffset();
  }

  /** Same propagation pattern as `applySubmenuWidth()`, but for the
   *  experimental sidebar's `--experimental-sidebar-width` CSS variable.
   *  Layout-aware: Classic forces 0 so the legacy submenu sits flush
   *  against the activity bar; Modern uses the collapsed-rail width when
   *  collapsed or the user's saved width when open. */
  private applyExperimentalSidebarWidth(): void {
    let width: number;
    if (this.legacyChromeEnabled) {
      width = 0;
    } else if (this.isExperimentalSidebarCollapsed) {
      width = AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_COLLAPSED_WIDTH;
    } else {
      width = this.experimentalSidebarWidth;
    }
    this.elementRef.nativeElement.style.setProperty(
      '--experimental-sidebar-width',
      width + 'px'
    );
    this.applyCanvasLeftOffset();
  }

  /** Sets `--canvas-left-offset` — distância do edge esquerdo do viewport
   *  até o início do canvas (mat-sidenav-content). Mode-agnostic: páginas
   *  consumidoras (ex: floating submit-bar de reviews-configuration) só
   *  precisam ler essa var pra se posicionar centradas no canvas,
   *  independente de Modern (offset = experimental-sidebar-width) ou
   *  Classic (offset = admin-submenu-width). */
  private applyCanvasLeftOffset(): void {
    let offset: number;
    if (this.legacyChromeEnabled) {
      offset = this.submenuWidth;
    } else if (this.isExperimentalSidebarCollapsed) {
      offset = AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_COLLAPSED_WIDTH;
    } else {
      offset = this.experimentalSidebarWidth;
    }
    this.elementRef.nativeElement.style.setProperty(
      '--canvas-left-offset',
      offset + 'px'
    );
  }

  ngOnInit(): void {
    // FormGroup do `<app-go-to-element>` — inicializado AQUI (em vez de
    // só em `set_go_to_element`) pra que a feature funcione no layout
    // moderno mesmo antes do usuário navegar para a seção Submissões
    // (na classic, o submenu só aparece após navegar; na modern, a
    // entrada fica permanente dentro do children expandido do item).
    this.searchForm = this.fb.group({
      elementId: ['']
    });

    // Keep `legacyChromeEnabled` in sync with the chair layout preference.
    // Fires once immediately (BehaviorSubject) with the persisted choice,
    // then again whenever the user toggles in the avatar menu — the
    // template's `[ngClass]` reacts and `.legacy-chrome-disabled` flips.
    // Re-apply the experimental sidebar width via the layout-aware helper
    // so Classic zeroes it (legacy submenu flushes against the activity
    // bar) and Modern restores the user's previous width.
    this.layoutService.layout$.subscribe(layout => {
      this.legacyChromeEnabled = layout === CHAIR_LAYOUTS.CLASSIC;
      this.applyExperimentalSidebarWidth();
    });

    this.layoutService.wideMode$.subscribe(active => {
      this.wideModeActive = active;
    });

    this.helpdeskOverlay.isOpen$.subscribe(open => {
      this.isSupportCardOpen = open;
    });

    this.authService.directUserIsAdmin().subscribe(userIsAdmin => {
      this.userIsAdmin = userIsAdmin;
    });
    this.userService.getUserFromToken().subscribe( user => {
      this.user = user;
      this.imageError = false;
    });

    // Restore the user's preferred submenu width from a previous session.
    const saved = localStorage.getItem(AdminEventSidebarComponent.SUBMENU_STORAGE_KEY);
    if (saved) {
      const n = parseInt(saved, 10);
      if (!isNaN(n)) {
        this.submenuWidth = Math.max(
          AdminEventSidebarComponent.SUBMENU_MIN_WIDTH,
          Math.min(AdminEventSidebarComponent.SUBMENU_MAX_WIDTH, n)
        );
      }
    }
    // Push the (possibly restored) width into the CSS variable.
    this.applySubmenuWidth();

    // Same restore + propagate for the experimental sidebar.
    const savedExp = localStorage.getItem(AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_STORAGE_KEY);
    if (savedExp) {
      const n = parseInt(savedExp, 10);
      if (!isNaN(n)) {
        this.experimentalSidebarWidth = Math.max(
          AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_MIN_WIDTH,
          Math.min(AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_MAX_WIDTH, n)
        );
      }
    }
    // Restore collapsed/open state — defaults to open if no preference saved.
    const savedCollapsed = localStorage.getItem(AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_COLLAPSED_KEY);
    this.isExperimentalSidebarCollapsed = savedCollapsed === 'true';

    // Restore favorited level-2 items + their user-chosen order. Stored
    // as a JSON array of link strings; an empty/missing/invalid value
    // yields an empty array.
    const savedFavorites = localStorage.getItem(AdminEventSidebarComponent.FAVORITES_STORAGE_KEY);
    if (savedFavorites) {
      try {
        const parsed = JSON.parse(savedFavorites);
        if (Array.isArray(parsed)) {
          this.favoritedLinks = parsed.filter(v => typeof v === 'string');
        }
      } catch { /* ignore malformed payload, fall back to empty array */ }
    }

    // Restore the (independent) expand/collapse state of Favoritos.
    // Only an explicit "false" collapses — missing/invalid preserves the
    // default-true so first-time users see their pinboard.
    const savedFavExpanded = localStorage.getItem(AdminEventSidebarComponent.FAVORITES_EXPANDED_KEY);
    if (savedFavExpanded !== null) {
      this.favoritesExpanded = savedFavExpanded !== 'false';
    }
    // Apply the appropriate width via the layout-aware helper, which picks
    // collapsed-rail / open / 0 (Classic) based on the current state.
    this.applyExperimentalSidebarWidth();

    this.adminService.sidebar = this;
    setTimeout(() => {
      this.initSidenav();
    });

    // Mobile-layout viewport detection. matchMedia callbacks run outside
    // the Angular zone in some browsers; wrap the assignment in
    // `ngZone.run` so the host `[ngClass]` reacts. Cleanup in ngOnDestroy.
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');
      this.mobileLayoutActive = this.mobileMediaQuery.matches;
      this.mobileMediaListener = (e: MediaQueryListEvent) => {
        this.ngZone.run(() => {
          this.mobileLayoutActive = e.matches;
          if (!this.mobileLayoutActive) {
            // Leaving mobile: drop any open mobile sheet.
            this.closeMobileSheet();
          }
          this.cdr.markForCheck();
        });
      };
      // `addEventListener('change', ...)` is the modern API; the deprecated
      // `addListener` is the fallback for older Safari. We use the modern
      // API only — Angular 11's supported browser matrix covers it.
      this.mobileMediaQuery.addEventListener('change', this.mobileMediaListener);
    }

    // `document:mousemove` FORA da zona do Angular. Durante o arrasto de resize o
    // handler só seta CSS custom properties (applyWidth = DOM direto, sem CD);
    // fora do arrasto ele faz early-return. Como @HostListener (na zona), ele
    // disparava change detection a CADA movimento do mouse no app INTEIRO — o que
    // em páginas de DOM grande (ex.: matriz de sugestões de atribuição) causava
    // reflows forçados de ~140ms por movimento. O start/end do resize (mousedown/
    // mouseup) continua na zona, então a classe .resizing-* reage normalmente.
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('mousemove', this.boundDocMouseMove);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Tenta restaurar o expanded-item quando event OU topItems mudam.
    // Em navegação entre eventos os dois inputs chegam (possivelmente em
    // ordem variável); a restauração só aplica quando ambos estão prontos.
    if (changes.event || changes.topItems) {
      this.tryRestoreExpandedForCurrentEvent();
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('mousemove', this.boundDocMouseMove);
    if (this.mobileMediaQuery && this.mobileMediaListener) {
      this.mobileMediaQuery.removeEventListener('change', this.mobileMediaListener);
      this.mobileMediaQuery = null;
      this.mobileMediaListener = null;
    }
  }

  // ─── Per-event "expanded item" persistence ───────────────────────────
  // Lembra qual level-1 item está expandido em cada evento. Quando o
  // usuário volta a um evento, restaura o mesmo expand state que ele
  // deixou. Favoritos é exceção (tem o seu próprio expand state global).

  private loadExpandedByEvent(): Record<string, string> {
    try {
      const raw = localStorage.getItem(AdminEventSidebarComponent.EXPANDED_BY_EVENT_STORAGE_KEY);
      return raw ? (JSON.parse(raw) as Record<string, string>) : {};
    } catch {
      return {};
    }
  }

  private persistExpandedForCurrentEvent(): void {
    if (!this.event?.id) { return; }
    const map = this.loadExpandedByEvent();
    const key = String(this.event.id);
    if (this.expandedExperimentalItem) {
      map[key] = this.stableItemKey(this.expandedExperimentalItem);
    } else {
      delete map[key];
    }
    try {
      localStorage.setItem(
        AdminEventSidebarComponent.EXPANDED_BY_EVENT_STORAGE_KEY,
        JSON.stringify(map)
      );
    } catch { /* quota/private mode — silencioso */ }
  }

  private tryRestoreExpandedForCurrentEvent(): void {
    if (!this.event?.id || !this.topItems || this.topItems.length === 0) { return; }
    const map = this.loadExpandedByEvent();
    const savedKey = map[String(this.event.id)];
    if (!savedKey) {
      // Sem state salvo pra esse evento — limpa qualquer expand herdado
      // de outro evento (caso o componente seja reusado em navegação).
      this.expandedExperimentalItem = null;
      return;
    }
    // Pula topItems[0] (Favoritos) — tem expand state separado.
    const match = this.topItems.slice(1).find(it => this.stableItemKey(it) === savedKey);
    this.expandedExperimentalItem = match ?? null;
  }

  // Identificador estável do item entre eventos (independente de eventId
  // no link). Prefere `label` (i18n key) que é stable; cai pra `link` se
  // não houver label.
  private stableItemKey(item: SidebarItem): string {
    if (!item) { return ''; }
    const label: any = (item as any).label;
    if (typeof label === 'string') { return label; }
    if (label?.full) { return label.full; }
    if (label?.short) { return label.short; }
    return item.link || '';
  }

  toggleExperimentalItem(item: SidebarItem): void {
    // Favoritos has its own expand state (`favoritesExpanded`), persisted
    // separately and independent of `expandedExperimentalItem`. Clicking
    // it leaves the currently-expanded "other" item alone, and clicking
    // any other item leaves Favoritos alone — they coexist.
    if (this.isFavoritesItem(item)) {
      this.favoritesExpanded = !this.favoritesExpanded;
      localStorage.setItem(
        AdminEventSidebarComponent.FAVORITES_EXPANDED_KEY,
        String(this.favoritesExpanded)
      );
    } else {
      this.expandedExperimentalItem = this.expandedExperimentalItem === item ? null : item;
      this.persistExpandedForCurrentEvent();
    }
    // Recompute scroll indicators after the expand/collapse animation
    // finishes (≈140ms in @expandCollapse) — the items area's scrollHeight
    // changes, so the bottom indicator may need to appear/disappear.
    setTimeout(() => this.updateExperimentalScrollIndicators(), 180);
  }

  /** True when `item` is the Favoritos level-1 entry. Convention: Favoritos
   *  is always `topItems[0]` (declared first in event-admin.component.ts).
   *  Centralised here so template/SCSS logic doesn't have to repeat the
   *  index-zero check. */
  isFavoritesItem(item: SidebarItem): boolean {
    return !!this.topItems && this.topItems.length > 0 && item === this.topItems[0];
  }

  /** True if the level-1 item should render in the navigation. Favoritos
   *  hides when the current event has no favorited children — there's no
   *  panel to surface, so the entry would be a dead end. All other items
   *  always render. */
  shouldShowTopItem(item: SidebarItem): boolean {
    if (this.isFavoritesItem(item)) {
      return this.childrenFor(item).length > 0;
    }
    return true;
  }

  /** topItems reordered for the Classic horizontal toolbar so Favoritos
   *  is the LAST entry (UX request — Favoritos sits to the right, after
   *  the canonical navigation groups). The underlying `topItems` array
   *  still has Favoritos at index 0, so all existing logic that depends
   *  on that (e.g. `isFavoritesItem`) keeps working. */
  private _topItemsClassicOrderedSrc: SidebarItem[] | null = null;
  private _topItemsClassicOrdered: SidebarItem[] = [];
  get topItemsClassicOrdered(): SidebarItem[] {
    if (!this.topItems || this.topItems.length === 0) return this.topItems;
    if (this._topItemsClassicOrderedSrc !== this.topItems) {
      this._topItemsClassicOrderedSrc = this.topItems;
      this._topItemsClassicOrdered = [...this.topItems.slice(1), this.topItems[0]];
    }
    return this._topItemsClassicOrdered;
  }

  /** Single source of truth for "is this level-1 item currently showing its
   *  children panel?". Favoritos reads `favoritesExpanded`; everything else
   *  reads the mutually-exclusive `expandedExperimentalItem`. Used by the
   *  template for both the `.expanded` visual class and the panel `*ngIf`. */
  isItemExpanded(item: SidebarItem): boolean {
    return this.isFavoritesItem(item)
      ? this.favoritesExpanded
      : this.expandedExperimentalItem === item;
  }

  /** True if any of `item`'s level-2 children matches the current URL.
   *  Used in the template to highlight a COLLAPSED level-1 item when
   *  the user is navigated into one of its children — without this,
   *  collapsing the group hides the only visual cue that the user is
   *  inside it. Pairs with `:not(isItemExpanded)` in the binding so
   *  the highlight only appears in the collapsed state (expanded
   *  groups already show the active child highlighted inside the
   *  open panel). */
  hasActiveChild(item: SidebarItem): boolean {
    const url = this.router?.url;
    if (!url) return false;
    // Match exato — mesmo critério que o `routerLinkActiveOptions:
    // { exact: true }` usado pelos itens de nível 2. Sem isso o
    // método marcava nível 1 errado quando algum filho tinha link
    // genérico (prefixo) que casava com sub-rotas de outros grupos.
    const children = this.childrenFor(item);
    return children.some(child => child?.link && child.link === url);
  }

  /** Click handler for level-2 entries inside a collapsed-mode flyout.
   *  Records the parent so that, when the user reopens the sidebar, the
   *  group they just navigated from is shown expanded. Favoritos has its
   *  own boolean — branch on it so we set the right state without leaking
   *  `topItems[0]` into `expandedExperimentalItem` (which would lock out
   *  the truly-exclusive accordion for the other groups). */
  onFlyoutChildClicked(parent: SidebarItem): void {
    if (this.isFavoritesItem(parent)) {
      if (!this.favoritesExpanded) {
        this.favoritesExpanded = true;
        localStorage.setItem(
          AdminEventSidebarComponent.FAVORITES_EXPANDED_KEY,
          'true'
        );
      }
    } else {
      this.expandedExperimentalItem = parent;
      this.persistExpandedForCurrentEvent();
    }
  }

  /** Template helper: true when the given level-2 item is favorited. */
  isFavorited(item: AdminSidebarItem): boolean {
    return !!item?.link && this.favoritedLinks.indexOf(item.link) !== -1;
  }

  /** `*ngFor` trackBy keyed on link — gives each row a stable identity
   *  across re-renders so DOM elements aren't recreated when
   *  `childrenFor()` returns a freshly-built array (which it does for
   *  Favoritos on every change-detection cycle). Without this, CDK
   *  drag-drop loses track of items mid-drag and the drop handler ends
   *  up with stale or zero-delta indices — the visible drag works but
   *  the reorder doesn't take. */
  trackChildByLink(_index: number, item: AdminSidebarItem): string {
    return item?.link || '';
  }

  /** Cached favorited children — same array reference returned across
   *  change-detection cycles when `favoritedLinks` and `topItems` are
   *  unchanged. Stability matters for CDK drag-drop: if `*ngFor`'s
   *  iterable reference flips on every CD (which it would with a fresh
   *  array build), CDK loses its measured item rects mid-drag and the
   *  drop indices come out stale or zero-delta. By rebuilding in-place
   *  (clearing + pushing on the same array) only when the signature
   *  changes, the array reference is preserved. */
  private _favoritedChildren: AdminSidebarItem[] = [];
  private _favoritedChildrenSig = '';

  /** Returns the level-2 children to render for the given level-1 item.
   *  The Favoritos item is conventionally `topItems[0]` (see
   *  event-admin.component.ts) and has its own children left empty there
   *  — its panel is computed here by indexing every level-2 item across
   *  the OTHER top-level groups and emitting them in the user-chosen
   *  order recorded in `favoritedLinks`. All other items just return
   *  their statically-defined children. Called from both the inline-
   *  accordion *ngFor and the collapsed-mode flyout *ngFor, so a single
   *  source of truth feeds both surfaces. */
  childrenFor(item: SidebarItem): AdminSidebarItem[] {
    if (this.isFavoritesItem(item)) {
      // Signature includes the favorited links + topItems identity so
      // both reorders (new link order) and route refreshes (new topItems
      // refs) invalidate the cache.
      const sig = `${this.favoritedLinks.join('|')}#${this.topItems?.length || 0}`;
      if (sig !== this._favoritedChildrenSig) {
        const byLink = new Map<string, AdminSidebarItem>();
        for (let i = 1; i < (this.topItems?.length || 0); i++) {
          const children = (this.topItems[i]?.children || []) as AdminSidebarItem[];
          for (const child of children) {
            if (child?.link) byLink.set(child.link, child);
          }
        }
        // Rebuild in place — preserves array reference across CD cycles.
        this._favoritedChildren.length = 0;
        for (const link of this.favoritedLinks) {
          const found = byLink.get(link);
          if (found) this._favoritedChildren.push(found);
        }
        this._favoritedChildrenSig = sig;
      }
      return this._favoritedChildren;
    }
    return (item.children || []) as AdminSidebarItem[];
  }

  /** Toggles the favorited state for a level-2 item. Called from the star
   *  button next to each child; `stopPropagation()` keeps the click from
   *  bubbling up to the anchor's routerLink (so toggling doesn't navigate),
   *  `preventDefault()` covers the same for keyboard activation.
   *  Typed as `MouseEvent` (not DOM `Event`) because the local `Event`
   *  identifier in this file refers to the JEMS Event model.
   *  Newly-favorited items append to the end of the order list — the
   *  user can drag-reorder afterwards via cdkDrag in the Favoritos panel. */
  // Flips true for ~500ms after a NEW item is favorited (not on
  // unfavorite). Template binds it to the Favoritos level-1 icon so a
  // brief pulse/scale animation gives a visual confirmation of the
  // action — same effect in both layouts.
  favoritesPulse = false;
  favoritesShake = false;
  private favoritesAnimTimer: any = null;


  // Set to the link of a row currently playing its "removing from
  // Favoritos" exit animation. The template binds `.unfavoriting` on
  // the matching row; CSS plays a brief slide/fade before the actual
  // splice happens (deferred from `onFavoriteBtnClick`).
  unfavoritingLink: string | null = null;

  /** Click handler for the row's right-side button. In a non-Favoritos
   *  panel the button is a star (favorite/unfavorite toggle, no exit
   *  animation needed because the row stays put). In the Favoritos
   *  panel it's an X — clicking it should remove the row from the
   *  Favoritos list, and we play a short slide-out animation on the
   *  row itself before the actual splice so the user sees the item
   *  leaving. */
  onFavoriteBtnClick(parent: SidebarItem, subitem: AdminSidebarItem, event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    if (!subitem?.link) return;
    // Star click on a non-favorited item: just add — no exit animation
    // anywhere (the row stays put in its native panel).
    if (!this.isFavoritesItem(parent) && !this.isFavorited(subitem)) {
      this.toggleFavorite(subitem, event);
      return;
    }
    // Unfavorite (either the X inside the Favoritos panel OR the star
    // on the already-favorited copy in its native panel). Either way,
    // the copy that should animate out is the one INSIDE Favoritos —
    // `[class.unfavoriting]` is template-gated by `isFavoritesItem`,
    // so setting `unfavoritingLink` triggers the exit only on the
    // Favoritos row.
    if (this.unfavoritingLink === subitem.link) return;
    this.unfavoritingLink = subitem.link;
    setTimeout(() => {
      if (this.unfavoritingLink !== subitem.link) return;
      this.unfavoritingLink = null;
      this.toggleFavorite(subitem, event);
    }, 260);
  }

  toggleFavorite(item: AdminSidebarItem, event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    if (!item?.link) return;
    const idx = this.favoritedLinks.indexOf(item.link);
    if (idx !== -1) {
      this.favoritedLinks.splice(idx, 1);
      this.triggerFavoritesAnim('shake');
    } else {
      this.favoritedLinks.push(item.link);
      this.triggerFavoritesAnim('pulse');
      this.markJustFavorited(item.link);
    }
    this.persistFavorites();
  }

  // Link of the newly-favorited item — bound to `.just-favorited` on the
  // inline experimental-sidebar-child row so the new row plays an enter
  // animation (inverse of `favorites-row-exit`: slides in from the right
  // while its vertical footprint expands from 0 → natural). Cleared
  // after the animation duration so the class doesn't linger.
  justFavoritedLink: string | null = null;
  private justFavoritedTimer: any = null;
  private markJustFavorited(link: string): void {
    if (this.justFavoritedTimer) {
      clearTimeout(this.justFavoritedTimer);
    }
    this.justFavoritedLink = null;
    setTimeout(() => {
      this.justFavoritedLink = link;
      this.justFavoritedTimer = setTimeout(() => {
        this.justFavoritedLink = null;
        this.justFavoritedTimer = null;
      }, 280);
    }, 0);
  }

  private triggerFavoritesAnim(kind: 'pulse' | 'shake'): void {
    if (this.favoritesAnimTimer) {
      clearTimeout(this.favoritesAnimTimer);
    }
    this.favoritesPulse = false;
    this.favoritesShake = false;
    // Defer so re-adding the class restarts the keyframe even when
    // triggered twice in quick succession.
    setTimeout(() => {
      if (kind === 'pulse') this.favoritesPulse = true;
      else this.favoritesShake = true;
      this.favoritesAnimTimer = setTimeout(() => {
        this.favoritesPulse = false;
        this.favoritesShake = false;
        this.favoritesAnimTimer = null;
      }, 500);
    }, 0);
  }

  /** Drop handler for cdkDrag reordering inside the Favoritos panel.
   *  `moveItemInArray` is imported from `@angular/cdk/drag-drop`;
   *  mutating the array in place keeps the existing reference so the
   *  *ngFor's identity-based diffing doesn't recreate every <a> on a
   *  reorder (only the moved one shifts). Persist the new order to
   *  localStorage so the layout survives across sessions. */
  onFavoriteReorder(event: CdkDragDrop<unknown>): void {
    if (event.previousIndex === event.currentIndex) return;
    // CDK's `previousIndex` / `currentIndex` are positions within the
    // RENDERED list (`_favoritedChildren`, filtered to items resolvable
    // in the current event's `topItems`). `favoritedLinks` is the FULL
    // user-wide list — possibly containing links from other events that
    // don't resolve here. Naively running `moveItemInArray(favoritedLinks,
    // prev, curr)` would reorder the wrong slots (some of which aren't
    // even visible). Instead: reorder the rendered-list links, then
    // splice them back into `favoritedLinks` at the same slots they
    // originally occupied, leaving unresolved links untouched.
    const renderedLinks = this._favoritedChildren.map(c => c.link);
    if (event.previousIndex >= renderedLinks.length || event.currentIndex >= renderedLinks.length) {
      return;
    }
    const reorderedRenderedLinks = [...renderedLinks];
    const [moved] = reorderedRenderedLinks.splice(event.previousIndex, 1);
    reorderedRenderedLinks.splice(event.currentIndex, 0, moved);
    // Walk `favoritedLinks`; each time we hit a slot that holds a
    // rendered link, replace it with the next link from the reordered
    // sequence. Slots holding unresolved links stay as-is.
    const renderedSet = new Set(renderedLinks);
    let writeIdx = 0;
    const next = this.favoritedLinks.map(link => {
      if (renderedSet.has(link)) {
        return reorderedRenderedLinks[writeIdx++];
      }
      return link;
    });
    this.favoritedLinks = next;
    this._favoritedChildrenSig = '';
    this.persistFavorites();
  }

  /** Single source of truth for writing the favorites array to storage.
   *  Used by both the toggle (add/remove) and the reorder handler. */
  private persistFavorites(): void {
    localStorage.setItem(
      AdminEventSidebarComponent.FAVORITES_STORAGE_KEY,
      JSON.stringify(this.favoritedLinks)
    );
  }

  /** Toggle the custom flyout for the given level-1 item. If a different
   *  item's flyout is currently open, switch to this one. If the same
   *  item's flyout is open, close it. Position is computed from the
   *  trigger button's bounding rect: the panel sits to the RIGHT of the
   *  sidebar with an 8px gap, and is shifted UP by 9px so the arrow's
   *  tip (built in SCSS at y=24 inside the panel) lands at the trigger
   *  icon's vertical center. */
  toggleFlyout(item: SidebarItem, triggerEl: HTMLElement, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    if (this.flyoutOpenForItem === item) {
      this.closeFlyout();
      return;
    }
    this.flyoutOpenForItem = item;
    this.flyoutOpenButton = triggerEl;
    this.positionFlyout(triggerEl);
  }

  closeFlyout(): void {
    // Reseta o `width` inline pinada por `freezeFlyoutWidth` ANTES de
    // destruir o aside via *ngIf — assim, se Angular reusar o nó (em vez
    // de recriar), a próxima abertura parte do `max-content` do CSS em
    // vez de herdar um valor de outro item.
    const el = this.experimentalFlyoutRef?.nativeElement;
    if (el) el.style.width = '';
    this.flyoutOpenForItem = null;
    this.flyoutOpenButton = null;
    if (this.flyoutCloseTimer) {
      clearTimeout(this.flyoutCloseTimer);
      this.flyoutCloseTimer = null;
    }
  }

  // Hover-based open/close. Mouseenter on a level-1 trigger opens (or
  // switches to) its flyout; mouseleave starts a short close timer that
  // gets cancelled if the cursor enters the flyout itself.
  private flyoutCloseTimer: any = null;
  openFlyoutOnHover(item: SidebarItem, triggerEl: HTMLElement): void {
    if (this.flyoutCloseTimer) {
      clearTimeout(this.flyoutCloseTimer);
      this.flyoutCloseTimer = null;
    }
    if (this.flyoutOpenForItem === item) return;
    this.flyoutOpenForItem = item;
    this.flyoutOpenButton = triggerEl;
    this.positionFlyout(triggerEl);
  }
  scheduleFlyoutClose(): void {
    if (this.flyoutCloseTimer) clearTimeout(this.flyoutCloseTimer);
    this.flyoutCloseTimer = setTimeout(() => {
      this.closeFlyout();
    }, 220);
  }
  cancelFlyoutClose(): void {
    if (this.flyoutCloseTimer) {
      clearTimeout(this.flyoutCloseTimer);
      this.flyoutCloseTimer = null;
    }
  }

  /** Compute the (top, left) for the flyout aside from the trigger
   *  button's viewport rect. Mirrors the legacy mat-menu shift:
   *  - top = rect.top - 9 → arrow tip at icon vertical center (panel
   *    padding-top 8 + arrow-top 16 = 24 from panel top; subtracting 9
   *    above puts the tip at rect.top + 15, matching the icon center
   *    for a 30-32px trigger).
   *  - left = rect.right + 8 → 8px breathing room between the sidebar
   *    edge and the arrow tail. */
  private positionFlyout(triggerEl: HTMLElement): void {
    const rect = triggerEl.getBoundingClientRect();
    this.flyoutTopPx = Math.round(rect.top - 9);
    this.flyoutLeftPx = Math.round(rect.right + 12);
    this.freezeFlyoutWidth();
  }

  /** Mede a largura natural necessária do flyout e pina como `width`.
   *
   *  Estratégia (Range API + getComputedStyle): pra cada row (item L2 +
   *  chip header), mede o texto cru via `Range.getBoundingClientRect`
   *  (independente de flex/constraints) e soma os paddings/border do row
   *  lidos via `getComputedStyle` (que pega os valores REAIS — `.draggable`
   *  com padding-left maior, chip com border, etc., todos captados sem
   *  hardcoding). Pega o maior, soma o overhead invariante (margem do row
   *  + padding do painel = 16px) e pina. Cap em 360px. */
  private freezeFlyoutWidth(): void {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = this.experimentalFlyoutRef?.nativeElement;
        if (!el) return;

        const range = document.createRange();
        let maxRowNeeded = 0;

        // Items L2.
        el.querySelectorAll<HTMLElement>('.experimental-flyout-item').forEach(item => {
          const label = item.querySelector<HTMLElement>('.experimental-flyout-item-label');
          if (!label) return;
          const icon = item.querySelector<HTMLElement>('.experimental-flyout-child-icon');

          range.selectNodeContents(label);
          const textW = range.getBoundingClientRect().width;

          const ics = getComputedStyle(item);
          const iconW = icon ? icon.getBoundingClientRect().width : 0;
          const iconMR = icon ? parseFloat(getComputedStyle(icon).marginRight) || 0 : 0;
          const need = (parseFloat(ics.paddingLeft) || 0)
                     + iconW
                     + iconMR
                     + textW
                     + (parseFloat(ics.paddingRight) || 0);
          if (need > maxRowNeeded) maxRowNeeded = need;
        });

        // Chip header (mesma lógica, com border incluso).
        const title = el.querySelector<HTMLElement>('.experimental-flyout-title-text');
        const chip = el.querySelector<HTMLElement>('.experimental-flyout-title');
        if (title && chip) {
          range.selectNodeContents(title);
          const textW = range.getBoundingClientRect().width;
          const ccs = getComputedStyle(chip);
          const need = (parseFloat(ccs.paddingLeft) || 0)
                     + textW
                     + (parseFloat(ccs.paddingRight) || 0)
                     + (parseFloat(ccs.borderLeftWidth) || 0)
                     + (parseFloat(ccs.borderRightWidth) || 0);
          if (need > maxRowNeeded) maxRowNeeded = need;
        }

        if (maxRowNeeded <= 0) return;

        // Overhead invariante: margem horizontal do row (4+4=8) + padding
        // horizontal do painel (4+4=8) + 2px buffer pra arredondamento subpixel.
        const finalWidth = Math.min(360, Math.ceil(maxRowNeeded + 18));
        el.style.width = `${finalWidth}px`;
      });
    });
  }

  /** Click handler for a row inside the flyout. Reuses the existing
   *  `onFlyoutChildClicked` logic (record parent as the "expanded
   *  group" so reopening the sidebar lands in the right place), then
   *  closes the flyout since the user is navigating away. */
  onFlyoutItemClick(parent: SidebarItem): void {
    this.onFlyoutChildClicked(parent);
    this.closeFlyout();
  }

  /** Recompute position on window resize while the flyout is open
   *  (the trigger's rect may have shifted). Scroll inside the sidebar
   *  doesn't move the trigger because the sidebar uses position:fixed
   *  itself, but a window-level resize can. */
  @HostListener('window:scroll')
  onWindowScrollRepositionFlyout(): void {
    if (this.flyoutOpenForItem && this.flyoutOpenButton) {
      // Só REPOSICIONA (top/left) — NÃO chama `freezeFlyoutWidth` (que lê
      // `getComputedStyle`/`Range.getBoundingClientRect` por item = forced reflow).
      // No scroll o CONTEÚDO do flyout não muda, só a posição; a largura já foi
      // fixada no open. Re-medir a cada scroll — e a animação do menu dispara scroll
      // por frame — travava a main-thread e fazia a animação "pular".
      const rect = this.flyoutOpenButton.getBoundingClientRect();
      this.flyoutTopPx = Math.round(rect.top - 9);
      this.flyoutLeftPx = Math.round(rect.right + 12);
    }
  }

  /** ESC dismisses the open flyout (matching native mat-menu behaviour).
   *  Also closes the mobile bottom sheet when present — combining both
   *  here avoids two competing @HostListener handlers on the same key. */
  @HostListener('document:keydown.escape')
  onEscapeClosesFlyout(): void {
    if (this.flyoutOpenForItem) this.closeFlyout();
    if (this.mobileSheetOpenFor || this.mobileMoreSheetOpen) this.closeMobileSheet();
  }

  ngAfterViewInit(): void {
    this.updateExperimentalScrollIndicators();
    // Flush any state changes that happened during component init so
    // the `'submenu-closed': content && !content.opened` ngClass
    // binding doesn't trip ExpressionChangedAfterItHasBeenCheckedError
    // (the mat-sidenav's `[opened]` resolves AFTER the parent ngClass
    // ran its first check, flipping the computed class on re-check).
    this.cdr.detectChanges();
  }

  onExperimentalItemsScroll(): void {
    this.updateExperimentalScrollIndicators();
  }

  /** Stops wheel scrolls over the sidebar's NON-scrollable regions
   *  (header, bottom rail) from chaining to the main page. The scrollable
   *  items area is handled by CSS `overscroll-behavior: contain`; for the
   *  rest, the wheel event has nowhere to go locally, so the browser would
   *  bubble it up to the document — preventDefault here stops that. */
  onSidebarWheel(event: WheelEvent): void {
    const target = event.target as HTMLElement | null;
    if (target && !target.closest('.experimental-sidebar-items')) {
      event.preventDefault();
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateExperimentalScrollIndicators();
  }

  /** Outside-click dismissal for the custom flyout. Listens on `click`
   *  (not mousedown) so cdkDrag's mousedown handler fires first on rows
   *  inside the flyout (drag handle clicks work). The trigger button's
   *  own click handler stopsPropagation, so toggling the same button
   *  won't reach here. A click on a DIFFERENT level-1 trigger will fall
   *  through to this handler (closing the old flyout) AND that trigger's
   *  own `toggleFlyout(...)` will run on the same click — they run in
   *  source order, so the new flyout opens correctly after the close. */
  @HostListener('document:click', ['$event'])
  onDocumentClickClosesFlyout(event: MouseEvent): void {
    if (!this.flyoutOpenForItem) return;
    const target = event.target as HTMLElement | null;
    if (!target) return;
    // Inside the flyout panel itself — keep open. Row clicks call
    // `onFlyoutItemClick` which closes explicitly.
    const flyoutEl = this.experimentalFlyoutRef?.nativeElement;
    if (flyoutEl && flyoutEl.contains(target)) return;
    // cdkDrag's drag-preview (and the drop-list while dragging) live
    // OUTSIDE the panel in the body root — clicking/releasing on them
    // shouldn't dismiss the flyout.
    if (target.closest('.cdk-drag-preview, .cdk-drag-placeholder')) return;
    // Click on the trigger button that owns the open flyout — the
    // trigger's own (click) handler called `toggleFlyout` which already
    // closed/toggled. Bail to avoid double-close.
    if (this.flyoutOpenButton && this.flyoutOpenButton.contains(target)) return;
    this.closeFlyout();
  }

  private updateExperimentalScrollIndicators(): void {
    const el = this.experimentalSidebarItemsRef?.nativeElement;
    if (!el) {
      this.experimentalItemsScrolledFromTop = false;
      this.experimentalItemsHasMoreBelow = false;
      return;
    }
    this.experimentalItemsScrolledFromTop = el.scrollTop > 0;
    // -1px tolerance for fractional pixel rounding in some browsers.
    this.experimentalItemsHasMoreBelow =
      el.scrollTop + el.clientHeight < el.scrollHeight - 1;
  }

  /** Icon-rail collapse width — wide enough for the 20px level-1 icons to
   *  stay centered with comfortable padding, matching the activity-bar's
   *  width so the two rails read as paired columns when both are visible. */
  static readonly EXPERIMENTAL_SIDEBAR_COLLAPSED_WIDTH = 48;

  toggleExperimentalSidebar(): void {
    this.isExperimentalSidebarCollapsed = !this.isExperimentalSidebarCollapsed;

    // Collapsed mode: shrink to the icon-rail width so the downstream chrome
    // shifts left but the experimental sidebar still shows its level-1 icons.
    // Re-open restores whatever width the user had previously set. Routed
    // through the layout-aware helper so Classic correctly stays at 0.
    this.applyExperimentalSidebarWidth();
    // Persist so the next page load remembers the user's preference.
    localStorage.setItem(
      AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_COLLAPSED_KEY,
      String(this.isExperimentalSidebarCollapsed)
    );
  }

  onExperimentalSidebarResizeStart(event: MouseEvent): void {
    this.isResizingExperimentalSidebar = true;
    this.experimentalResizeStartX = event.clientX;
    this.experimentalResizeStartWidth = this.experimentalSidebarWidth;
    event.preventDefault();
    event.stopPropagation();
  }

  onSubmenuResizeStart(event: MouseEvent): void {
    this.isResizingSubmenu = true;
    this.resizeStartX = event.clientX;
    this.resizeStartWidth = this.submenuWidth;
    event.preventDefault();
    event.stopPropagation();
  }

  /** Single mousemove listener that dispatches to whichever resize is
   *  active. Using a single @HostListener per event avoids any ambiguity
   *  with multiple decorators on the same event name. */
  // Registrado manualmente FORA da zona em ngOnInit (não @HostListener, que
  // rodaria na zona e dispararia CD a cada mousemove no app inteiro).
  onDocumentMouseMove(event: MouseEvent): void {
    if (this.isResizingSubmenu) {
      const dx = event.clientX - this.resizeStartX;
      const next = this.resizeStartWidth + dx;
      this.submenuWidth = Math.max(
        AdminEventSidebarComponent.SUBMENU_MIN_WIDTH,
        Math.min(AdminEventSidebarComponent.SUBMENU_MAX_WIDTH, next)
      );
      this.applySubmenuWidth();
      return;
    }
    if (this.isResizingExperimentalSidebar) {
      const dx = event.clientX - this.experimentalResizeStartX;
      const next = this.experimentalResizeStartWidth + dx;
      this.experimentalSidebarWidth = Math.max(
        AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_MIN_WIDTH,
        Math.min(AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_MAX_WIDTH, next)
      );
      this.applyExperimentalSidebarWidth();
    }
  }

  @HostListener('document:mouseup')
  onDocumentMouseUp(): void {
    if (this.isResizingSubmenu) {
      this.isResizingSubmenu = false;
      localStorage.setItem(
        AdminEventSidebarComponent.SUBMENU_STORAGE_KEY,
        String(this.submenuWidth)
      );
    }
    if (this.isResizingExperimentalSidebar) {
      this.isResizingExperimentalSidebar = false;
      localStorage.setItem(
        AdminEventSidebarComponent.EXPERIMENTAL_SIDEBAR_STORAGE_KEY,
        String(this.experimentalSidebarWidth)
      );
    }
  }

  initSidenav() {
    if (this.topItems) {
      // Checks if is inside a homeItem url of the topItems
      let mainItem: string;
      let homeItem = false;
      this.topItems[0].children.forEach(child => {
        if (child.link == this.router.url) {
          homeItem = true;
        }
      });

      // If the current url isn't on the home item, get the mainItem by the current url
      if (homeItem){
        mainItem = this.topItems[0].link;
      } else {
        mainItem = this.router.url.split('/').slice(0,4).join('/');
      } 

      // Specific cases when refreshing, the url is unique and the mainItem wouldn't be found in the topItems
      if(this.router.url.endsWith('/tracks')){
        mainItem = 'submissions'
      }else if(this.router.url.endsWith('submission-files') || this.router.url.endsWith('bibtex-export')){
        mainItem = 'publication'
      }
    
      // Match topItems whose link is a prefix of the current URL (or the
      // computed mainItem for special-cased keywords like 'submissions' /
      // 'publication'). Pick the longest-prefix match so that nested
      // groups (e.g. `/people/members` under `/people`) resolve to the
      // most specific top item.
      const candidates = this.topItems.filter((item) =>
        item.link === mainItem || mainItem.startsWith(item.link + '/') || item.link.includes(mainItem)
      );
      this.selectedItem = candidates.sort((a, b) => b.link.length - a.link.length)[0];
      if(this.selectedItem){
        this.selectedItem.selected = true;
      }
    }
    this.set_go_to_element();
  }

  changeContent(newSelectedItem: SidebarItem) {
    let shouldClose = false;
    if (this.selectedItem === newSelectedItem) {
      this.selectedItem.selected = !this.selectedItem.selected;
      shouldClose = true;
    } else {
      if (this.selectedItem) {
        this.selectedItem.selected = false;
      }
      this.selectedItem = newSelectedItem;
      this.selectedItem.selected = true;
    }

    // `childrenFor()` resolves Favoritos' children dynamically (the
    // statically-defined `children` array is empty for it); other items
    // pass through to `item.children`. Using it here lets the submenu
    // open for Favoritos when the user has at least one starred item.
    const hasChildren = this.childrenFor(this.selectedItem).length > 0;
    // Guard: `contentNav` (ViewChild de `#content`) pode ser undefined em
    // certos caminhos de boot (ex.: layout moderno onde o `<mat-sidenav>`
    // do classic não é materializado, ou full-view-mode no init). Sem o
    // guard, qualquer clique na activity-bar nesses estados crashava a
    // navegação. Investigar causa-raiz quando der tempo.
    if (this.contentNav) {
      if (!this.contentNav.opened && hasChildren) {
        this.contentNav.open();
      } else if (!(this.contentNav.opened && hasChildren) || shouldClose) {
        this.contentNav.close();
        shouldClose = false;
      }
    }
    this.set_go_to_element();
  }

  set_go_to_element() {
    this.selectedElement = this.selectedItem?.link?.split('/').pop();
    switch (this.selectedElement) {
      case 'submissions':
        this.selectedItemMenu = true;
        break;

      case 'people':
        this.selectedItemMenu = true;
        break;

      default:
        this.selectedItemMenu = false;
        break;
    }
    this.searchForm = this.fb.group({
      elementId: ['']
    });
  }

  subitemSelect(subitem: SidebarItem) {
    if (this.isMobile && this.contentNav) {
      this.contentNav.close();
    }
  }

  openSidenav() {
    let open: boolean;
    if (!this.selectedItem) {
      if(this.isMobile){
        open = false;
      } else {
        open = true;
      }
    } else {
      // `childrenFor()` resolves the dynamic children for Favoritos
      // (which has an empty static `children` array). Without this,
      // the `[opened]` binding would force-close the submenu on the
      // next change-detection cycle even after `changeContent()` had
      // just opened it.
      open = this.childrenFor(this.selectedItem).length > 0;
    }
    return open;
  }

  openAvatarMenu(): void{
    this.avatarProfile.openMenu(this.expUserBtn.nativeElement);
    this.isAvatarProfileOpen=true;
    this.avatarProfile.closed.subscribe(()=>{
      this.isAvatarProfileOpen=false;
    });
  }

  get isMobile(): boolean {
    return window.innerWidth < 768;
  }

  canShow(item: SidebarItem) {
    return this.userIsAdmin || !(item.label as string).endsWith('proceedings');
  }

  openHelpDialog(){
    const dialogRef = this.dialog.open(HelpDialogComponent,{maxWidth:"400px"});
  }
}
